"use strict";

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var utils_1 = require("@8base-react/utils");

var PermissionsContext_1 = require("./PermissionsContext");

var withPermissions = function withPermissions(WrappedComponent) {
  var _a;

  return _a =
  /*#__PURE__*/
  function (_react_1$default$Comp) {
    _inherits(WithPermissions, _react_1$default$Comp);

    function WithPermissions() {
      _classCallCheck(this, WithPermissions);

      return _possibleConstructorReturn(this, _getPrototypeOf(WithPermissions).apply(this, arguments));
    }

    _createClass(WithPermissions, [{
      key: "render",
      value: function render() {
        var _this = this;

        return react_1.default.createElement(PermissionsContext_1.PermissionsContext.Consumer, null, function (_ref) {
          var permissions = _ref.permissions;
          return react_1.default.createElement(WrappedComponent, Object.assign({}, _this.props, {
            permissions: permissions
          }));
        });
      }
    }]);

    return WithPermissions;
  }(react_1.default.Component), _a.displayName = "withPermissions(".concat(utils_1.getDisplayName(WrappedComponent), ")"), _a;
};

exports.withPermissions = withPermissions;